import * as _ from "lodash";
import * as log from "loglevel";
import * as moment from "moment";
import * as React from "react";

import mobx, { observable } from "mobx";
import { inject, observer, Provider } from "mobx-react";
import { Link } from "react-router-dom";
import { Grid, Icon, Modal, Segment, SemanticICONS, Table } from "semantic-ui-react";
import { DialogService } from "../../services/dialog-service";
import { AppStore } from "../../stores/app-store";
import { AuthStore } from "../../stores/auth-store";
import { App } from "../../stores/models/app";
import { Project, UserApp } from "../../stores/models/project";
import { ProjectApp } from "../../stores/models/project-app";
import { User } from "../../stores/models/user";
import { ProjectAppStore } from "../../stores/project-app-store";
import { ProjectStore } from "../../stores/project-store";
import { UserStore } from "../../stores/user-store";
import { EditorPane } from "../common/editor-pane";
import { ProjectGridItem } from "./project-grid-item";

declare var toastr: any;

interface IProjectDetailsProps {
	appStore?: AppStore;
	projectAppStore?: ProjectAppStore;
	authStore?: AuthStore;
	project?: Project;
	show?: boolean;
	onClose?(): void;
}

interface IProjectDetailsState {
	errorMessage?: string;
}

@inject("appStore", "projectAppStore", "authStore") @observer
export class ProjectDetails extends React.Component<IProjectDetailsProps, IProjectDetailsState> {
	constructor(props, state) {
		super(props, state);
		this.state = { "errorMessage": null };

		this.handleClose = this.handleClose.bind(this);
	}

	handleClose() {
		if (this.props.onClose) {
			this.props.onClose();
		}
	}


	render() {
		if (!this.props.show) {
			return null;
		}

		const { appStore, projectAppStore, project } = this.props;

		let dueDate: string = "";
		let usePurge = false;
		if (project.purgeDate && project.purgeDate.length > 0) {
			usePurge = true;
			dueDate = moment(project.purgeDate.split("T")[0]).format("M/D/YYYY");
		}
		else if (project.testLinkDue && project.testLinkDue.length > 0) {
			dueDate = moment(project.testLinkDue.split("T")[0]).format("M/D/YYYY");
		}

		let client = this.props.authStore.user.accountType !== 0;
		let color = project.color;
		let status = project.status;

		if (client) {
			switch (project.status) {
				case "New Project":
				case "Configuration":
				case "Programming":
				case "Testing":
					color = "jibunu-orange";
					status = "In Production";
					break;
				default:
					break;
			}
		}

		let surveyProject = project.surveyId;

		return (
			<div>
				<Modal open={this.props.show} onClose={this.props.onClose} size="tiny" closeIcon>
					<Modal.Header className={`jibunu-white-text ${color}-gradient`} >
						<span className="left floated text project-name">{project.name}</span>
						<span className="right floated text" style={{ "float": "right" }}>
							{project.surveyId}
						</span>
					</Modal.Header>
					<Modal.Content>
						<Segment.Group raised>
							<Segment className="noSegmentPadding">
								<Table basic="very" celled>
									<Table.Body>
										<Table.Row>
											<Table.Cell><b>Client Name</b></Table.Cell>
											{project.clientProjectName.length > 0 &&
												<Table.Cell><b>Client Project Number</b></Table.Cell>
											}
										</Table.Row>
										<Table.Row>
											<Table.Cell>
												{project.clientName}
											</Table.Cell>
											{project.clientProjectName.length > 0 &&
												<Table.Cell>{project.clientProjectName}</Table.Cell>
											}
										</Table.Row>
									</Table.Body>
								</Table>
							</Segment>
							<Segment className="noSegmentPadding">
								<Table basic="very" celled>
									<Table.Body>
										<Table.Row>
											{status !== "Appy" &&
												<Table.Cell><b>Status</b></Table.Cell>
											}
											{surveyProject &&
												<Table.Cell error={usePurge && status === "Closed"} warning={usePurge && status === "Purged"}>
													{usePurge ?
														(status === "Purged" ?
															<b>Data Was Purged On</b>
															:
															<b>Purge Date</b>
														)
														:
														<b>Test Link Due</b>
													}
												</Table.Cell>
											}
											<Table.Cell><b>Project Manager</b></Table.Cell>
										</Table.Row>
										<Table.Row>
											{status !== "Appy" &&
												<Table.Cell><span className="status-text">{status}</span></Table.Cell>
											}
											{surveyProject &&
												<Table.Cell error={usePurge && status === "Closed"} warning={usePurge && status === "Purged"}>
													<span className={usePurge ? "" : "status-text"}>{dueDate}</span>
												</Table.Cell>
											}
											<Table.Cell><span className="status-text">{project.manager}</span></Table.Cell>
										</Table.Row>
									</Table.Body>
								</Table>
							</Segment>
							{(this.props.authStore.user.hasInternalAccess() || project.status != "Purged") &&
								<Segment>
									<Grid divided="vertically">
										{_.sortBy(project.userApps, ["name"]).map((app: UserApp) => {
											let foundApp = appStore.findById(app.id);
											return (
												<Grid.Row key={`${project.id}-${app.id}`} className="grid-row-hover" href={app.disabled ? null : foundApp.url + "?jpt=" + app.token} as="a" target="_blank">
													<Grid.Column width={3}>
														<Icon name={foundApp.icon as SemanticICONS} size="huge" className={app.disabled ? `jibunu-gray` : `jibunu-blue`} />
													</Grid.Column>
													<Grid.Column width={13}>
														<div className={app.disabled ? `jibunu-gray` : `jibunu-blue`}><b>{foundApp.name}</b></div>
														<div style={{ "color": "black" }}>{foundApp.description}</div>
													</Grid.Column>
												</Grid.Row>
											);
										})}
									</Grid>
								</Segment>
							}
						</Segment.Group>
					</Modal.Content>
				</Modal>
			</div>
		);
	}
}





// WEBPACK FOOTER //
// ./src/views/projects/project-details.tsx